import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { CustomerImageModule } from '../customer/image/customer-image.module';
import { CustomerManageService } from '../customer/shared/customer-manage.service';
import { CustomerService } from '../customer/shared/customer.service';
import { SearchModule } from '../shared/components/search/search.module';
import { ValidationResultsModule } from '../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { BaseCorrespondenceComponent } from './base/correspondence-base.component';
import { CreateCorrespondenceNoSearchModalComponent } from './create/create-correspondence-no-search-modal.component';
import { CreateCorrespondenceNoSearchComponent } from './create/create-correspondence-no-search.component';
import { CreateCorrespondenceModule } from './create/create-correspondence.module';
import { ViewCorrespondenceComponent } from './view/correspondence-view.component';

@NgModule({
    declarations: [
        CreateCorrespondenceNoSearchComponent,
        CreateCorrespondenceNoSearchModalComponent
    ],
    providers: [
        CustomerService,
        CustomerManageService
    ],
    imports: [
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        CreateCorrespondenceModule,
        CustomerImageModule,
        MVMSpinnerBtnModule,
        SearchModule,
        ValidationResultsModule,
        ToastModule
    ],
    exports: [
        BaseCorrespondenceComponent
    ]
})
export class CorrespondenceNoSearchModule { }
